import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { ModalController } from '@ionic/angular';
import * as uuid from 'uuid';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal-dados-bancarios',
  templateUrl: './modal-dados-bancarios.component.html',
  styleUrls: ['./modal-dados-bancarios.component.scss'],
})
export class ModalDadosBancariosComponent {
  @Input() isEditMode: boolean = false;
  @Input() data: any = {};
  form: FormGroup;
  status: boolean = true;
  id: any = null;
  tempId: any = null;
  subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    public toastService: ToastService,
    private modalCtrl: ModalController
  ) {
    this.form = this.fb.group({
      banco: [null, [Validators.required]],
      agencia: [null, [Validators.required]],
      conta: [null, [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (this.isEditMode && this.data) {
      this.form.patchValue({
        banco: this.data.banco,
        agencia: this.data.agencia,
        conta: this.data.conta,
      });
      this.id = this.data.id;
      this.tempId = this.data.tempId;
    }
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    const formValues = this.form.value;
    const id = this.isEditMode ? this.data.id : '';
    const tempId = this.isEditMode ? this.tempId : uuid.v1();

    const formattedObj = {
      id: id,
      tempId: tempId,
      banco: formValues.banco,
      agencia: formValues.agencia,
      conta: formValues.conta,
    };

    const msg = this.isEditMode
      ? 'Dados bancários editado com sucesso'
      : 'Dados bancários inserido com sucesso';

    this.toastService.showSuccess(msg);
    return this.modalCtrl.dismiss(formattedObj, 'confirm');
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
